import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'
import { H3 } from '@components/Text'

export const Wrapper = styled.section`
  padding-top: 72px;
  padding-bottom: 64px;
  background-color: var(--vila-olimpia-10);

  @media (min-width: ${getBreakpoint('xl')}px) {
    padding-top: 64px;
    padding-bottom: 56px;
  }
`

export const Title = styled(H3)`
  font-weight: 300;
  line-height: 24px;
  color: var(--primary-text);

  span {
    font-weight: 700;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    text-align: center;
  }
`

export const CompaniesLogos = styled(Image)`
  max-width: 156px;
  height: 96px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 16px;
  }
`
